<template>
 <a :href="linkUrl">
     <h4 class="link-text">Play Now</h4>
 </a>
</template>
<script>
export default {
    name: "AlexaLink",
    props: ["game", "source"],
    computed: {
        linkUrl() {
            switch (this.game) {
                case "PuzzleOfTheDay":
                    return `https://alexa-skills.amazon.com/apis/custom/skills/amzn1.ask.skill.ec157566-b7b7-485f-963f-2c2942154e9a/tasks/PlayPuzzleOfTheDay/versions/1?source=${this
                        .source || "unknown"}`;
                case "EscapeTheRoom":
                    return "https://alexa-skills.amazon.com/apis/custom/skills/amzn1.ask.skill.024e0de3-2e98-408f-9e63-3ab4544480e0/launch";
                case "EscapeTheRoom2":
                    return "https://alexa-skills.amazon.com/apis/custom/skills/amzn1.ask.skill.a635e0e2-6a0a-4df2-95f9-72051cdab3fa/launch";
                case "AngelInvestor":
                    return "https://alexa-skills.amazon.com/apis/custom/skills/amzn1.ask.skill.051de603-56d2-4e93-a4de-48d409a6215f/launch";
                case "GameOfWords":
                    return "https://alexa-skills.amazon.com/apis/custom/skills/amzn1.ask.skill.57d54106-9322-433d-883b-18358915d4f9/launch";
                case "ChristmasEscape":
                    return "https://alexa-skills.amazon.com/apis/custom/skills/amzn1.ask.skill.4c84f3d7-0838-4ec6-bfbb-0bd2cf656598/launch";
                case "WordPlay":
                    return "https://alexa-skills.amazon.com/apis/custom/skills/amzn1.ask.skill.94edb394-b4b4-4f4a-897a-0cdcc82ded59/launch";
                case "EscapeTheAirplane":
                    return "https://alexa-skills.amazon.com/apis/custom/skills/amzn1.ask.skill.0ccd505b-3605-4abe-94db-7b36e6c02f82/launch";
                case "WordWiz":
                    return "https://alexa-skills.amazon.com/apis/custom/skills/amzn1.ask.skill.ce2b2675-1b4c-4cdd-a9a1-468fe055cf99/launch";
            }
        }
    }
};
</script>


<style scoped>
.link-text {
    display: inline;
    padding-left: 10px;
}
</style>



// WEBPACK FOOTER //
// src/components/AlexaLink.vue